import { render, staticRenderFns } from "./UserSubscription.vue?vue&type=template&id=b5d9bd76&scoped=true"
import script from "./UserSubscription.vue?vue&type=script&lang=js"
export * from "./UserSubscription.vue?vue&type=script&lang=js"
import style0 from "./UserSubscription.vue?vue&type=style&index=0&id=b5d9bd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d9bd76",
  null
  
)

export default component.exports